import { Description } from '@casavo/base-ui'
import cn from 'classnames'
import getConfig from 'next/config'
import Image from 'next/image'
import React from 'react'

import Check from '@/components/Icon/Check'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { TENANTS } from '@/lib/tenants/constants'
import { Tenants } from '@/lib/tenants/types'
import { color } from '@/shared-styles/styles.css'

export const LabelWithCheck: React.FC<{ tenant?: Tenants }> = ({ children, tenant = TENANTS.casavo }) => {
  const {
    publicRuntimeConfig: { imageBasePath },
  } = getConfig()
  return (
    <div
      className={sprinkles({
        display: 'flex',
        paddingBottom: 'm',
      })}
    >
      {tenant === TENANTS.casavo && <Check className={cn(color['orange600'], sprinkles({ flexShrink: 0 }))} />}
      {tenant === TENANTS.ucsc && (
        <Image alt="tick" height={20} src={`${imageBasePath}/images/tenants/ucsc/single-tick.svg`} width={20} />
      )}
      <Description className={sprinkles({ paddingLeft: 's' })}>{children}</Description>
    </div>
  )
}
